import React, { FC } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import GlobalStyles from "../styles/GlobalStyles";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import red from "@material-ui/core/colors/red";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/date-fns";
import { es } from "date-fns/locale";

//Styles

interface Props {
  value: Date | null;
  disabled?: boolean;
  label: string;
  error?: boolean;
  helperText: string;
  focusedColor?: string;
  underlineColor?: string;
  disableFuture?: boolean;
  onChange: (date: Date | null) => void;
}

const DatePickerComponent: FC<Props> = (p) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      picker: {
        width: "100%",
        marginTop: 0,
        "& label.Mui-focused": {
          color: p.focusedColor || GlobalStyles.secondaryColor,
        },
        "& label": {
          color: GlobalStyles.thirdColor,
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: p.underlineColor || GlobalStyles.secondaryColor,
        },
        "& .MuiInput-underline:before": {
          borderBottomColor: GlobalStyles.thirdColor,
        },
        "& label.Mui-error": {
          color: GlobalStyles.primaryColor,
        },
        "& MuiButton-label": {
          color: GlobalStyles.primaryColor,
        },
      },
    })
  );

  const materialTheme = createMuiTheme({
    palette: {
      primary: red,
    },
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: GlobalStyles.secondaryColor,
        },
      },
      MuiPickersDay: {
        day: {
          color: GlobalStyles.secondaryColor,
        },
        daySelected: {
          backgroundColor: GlobalStyles.primaryColor,
          "&:hover": {
            backgroundColor: GlobalStyles.secondaryColor,
          },
        },
        dayDisabled: {
          color: GlobalStyles.secondaryColor,
        },
        current: {
          color: GlobalStyles.primaryColor,
        },
      },
      MuiPickersYear: {
        yearSelected: {
          color: GlobalStyles.primaryColor,
          "&:active": {
            color: GlobalStyles.secondaryColor,
          },
        },
      },
      MuiPickersMonth: {
        monthSelected: {
          color: GlobalStyles.primaryColor,
          "&:active": {
            color: GlobalStyles.secondaryColor,
          },
        },
      },
    },
  });

  const classes = useStyles();
  return (
    <>
      <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
        <ThemeProvider theme={materialTheme}>
          <DatePicker
            className={`${classes.picker}`}
            margin="normal"
            okLabel="Aceptar"
            cancelLabel="Cancelar"
            disableFuture={p.disableFuture}
            openTo="year"
            views={["year", "month", "date"]}
            label={p.label}
            format="dd/MM/yyyy"
            value={p.value}
            onChange={p.onChange}
            error={p.error}
            helperText={p.helperText}
            disabled={p.disabled}
          />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </>
  );
};

export default DatePickerComponent;
